export type OEmbedMeta = {
  html: string;
  url: string;
  width: number;
  height: string | null;
};

export const fetchOEmbedMeta = async (
  api: string,
  url: string
): Promise<OEmbedMeta> => {
  const res = await fetch(
    `https://apiv2.app.aula.education/meta/scrap/oembed?api=${api}&url=${url}`
  );

  return res.json();
};
